import React, { useEffect, useState } from "react";
import { Table, Switch } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { getUsers, updateUserStatus, deleteUser } from "../features/cutomers/customerSlice";
import { Image } from "antd";
import { Tag } from "antd";
import { Link } from 'react-router-dom';
import { Input } from 'antd';
import { Select } from 'antd';
import { IoSearchOutline } from "react-icons/io5";
import { message as msg } from 'antd';
import { Popconfirm } from 'antd';

const Customers = () => {
  const [messageApi, contextHolder] = msg.useMessage();
  const [searchQuery, setSearchQuery] = useState('');

  const handleInputChange = (event) => {
    setSearchQuery(event.target.value);
  };

  const dispatch = useDispatch();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 1000,
    key: '',
    status: '',
  });

  // Fetch data on component mount and pagination change
  useEffect(() => {
    const { current, pageSize, key, status } = pagination;
    const skip = (current - 1) * pageSize;

    // dispatch(getUsers({ limit: pageSize, skip }));

    dispatch(getUsers({ limit: pageSize, skip, key: key, status: status }));

  }, [dispatch, pagination.current, pagination.pageSize, pagination.key, pagination.status])

  const { isLoading, customers, total } = useSelector((state) => state.customer);

  const handleTableChange = (pagination) => {
    setPagination({
      ...pagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    });
  };

  useEffect(() => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      total: total,
    }));
  }, [total]);

  const handleStatusChange = (checked, record) => {
    const newStatus = checked ? 1 : 2;
    dispatch(updateUserStatus({ id: record.id, data: { status: newStatus } }));
    messageApi.open({
      type: 'success',
      content: "User status updated successfully",
    });
  };

  const handleNotificationChange = (checked, record) => {
    dispatch(updateUserStatus({ id: record.id, data: { enable_notification: checked } }));
    messageApi.open({
      type: 'success',
      content: `Notification is ${checked ? 'enabled' : 'disabled'} successfully`,
    });
  };

  const handleDiamondPassChange = (checked, record) => {
    dispatch(updateUserStatus({ id: record.id, data: { is_diamond_pass_user: checked } }));
    messageApi.open({
      type: 'success',
      content: `Use is  ${checked ? 'added' : 'removed'} for diamond pass section`,
    });
  };

  const handleDelete = (id) => {    
    dispatch(deleteUser(id));
    messageApi.open({
      type: 'success',
      content: `User deleted successfully`,
    });
  }

  const columns = [
    {
      title: 'Image',
      dataIndex: 'image',
      key: 'image',
      render: (text, record) => (
        <Image
          width={40}
          height={40}
          style={{ borderRadius: "50%" }}
          src={record.profile_pic_url}
          alt={`${record.first_name} ${record.last_name}`}
        />
      ),
    },
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => a.name.length - b.name.length,
      render: (text, record) => `${record.first_name} ${record.last_name}`,
    },
    {
      title: "Age",
      dataIndex: "age",
    },
    {
      title: "Likes",
      dataIndex: "likes",
    },
    {
      title: "Dislikes",
      dataIndex: "dislikes",
    },
    {
      title: "gender",
      dataIndex: "gender",
    },
    {
      title: "Date Type",
      dataIndex: "date_type",
      render: (_, { date_type }) => (
        <>
          {date_type.map((tag) => {

            let color = 'green';
            if (tag === 'yacht_ride') {
              color = 'volcano';
            }
            if (tag === 'clubbing') {
              color = 'geekblue';
            }
            return (
              <Tag color={color} key={`${tag}-${Math.random()}`}>
                {tag}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: "Interest",
      dataIndex: "interest",
      render: (_, { interest }) => (
        <>
          {interest.map((tag) => {


            let color = 'green';

            if (tag === 'female') {
              color = 'volcano';
            }

            if (tag === 'non-binary') {
              color = 'geekblue';
            }
            return (
              <Tag color={color} key={`${tag}-${Math.random()}`}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Notification',
      dataIndex: 'enable_notification',
      key: 'enable_notification',
      render: (enable_notification, record) => (
        <Switch
          checked={enable_notification}
          onChange={(checked) => handleNotificationChange(checked, record)}
        />
      ),
    },
    // {
    //   title: 'Diamond Profile',
    //   dataIndex: 'is_diamond_pass_user',
    //   key: 'is_diamond_pass_user',
    //   render: (is_diamond_pass_user, record) => (
    //     <Switch
    //       checked={is_diamond_pass_user}
    //       onChange={(checked) => handleDiamondPassChange(checked, record)}
    //     />
    //   ),
    // },    
    {
      title: 'Block',
      dataIndex: 'status',
      key: 'status',
      render: (status, record) => (
        <span>
          <Switch
            checked={status === 1}
            onChange={(checked) => handleStatusChange(checked, record)}
          />
        </span>
      ),
    },
    {
      title: 'Deleted',
      dataIndex: 'is_deleted',
      key: 'is_deleted',
      render: (_, { is_deleted }) => (
        <Tag color={is_deleted ? 'red' : 'green'} key={`${Math.random()}`}>
          {is_deleted ? 'Yes': 'No'}
        </Tag>
      )
    },
    {
      title: 'Created at',
      render: (record) => {
        const date = new Date(record.createdAt);
        const formattedDate = date.toLocaleDateString('en-US', {
          weekday: 'long',
          year: 'numeric',
          month: 'long',
          day: 'numeric',
        });
        return `${formattedDate}`;
      },
      key: 'reportedAt',
    },
    {
      title: 'Action',
      dataIndex: '',
      key: 'x',
      render: (status, record) => (
        <>
          <a href={`/admin/profile/${record.id}`} target="_blank" rel="noopener noreferrer">
            View
          </a>
          <span style={{ margin: "0 10px" }}>|</span>
          <a href={`/admin/customers/${record.id}/edit`} target="_blank" rel="noopener noreferrer">
            Edit
          </a>
          <span style={{ margin: "0 10px" }}>|</span>
          <Link
            to="#"
            onClick={(e) => e.preventDefault()} // Prevent navigation since Popconfirm handles the action
            style={{ color: 'red' }}
          >
            <Popconfirm
              title={`Are you sure you want to delete profile ID ${record.first_name}?`}
              onConfirm={() => handleDelete(record._id)} // Call your delete handler function
              okText="Yes"
              cancelText="No"
            >
              Delete
            </Popconfirm>
          </Link>
        </>
      ),
    },
  ];

  // Handle key down events on search
  const handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      setPagination({
        ...pagination,
        current: 1,
        key: searchQuery,
      });
    }
  };

  /** Handle dorp down for status is changed call search */
  const handleChange = (value) => {
    console.log(`selected ${value}`);
    setPagination({
      ...pagination,
      current: 1,
      status: value
    });
  };

  return (
    <div>
      {contextHolder}
      <div className="row-space-between">
        <h3 className="mb-4 title">Users</h3>
        <div className="my-row">
          <div className="mr-5">
            {/* <IoSearchOutline className="fs-4" /> */}
            <Input placeholder="Search users"
              value={searchQuery}
              onChange={handleInputChange}
              onKeyDown={handleKeyDown}
              prefix={<IoSearchOutline className="fs-4" />}
            />
          </div>

          <div>
            <Select
              defaultValue="all"
              style={{ width: 120 }}
              onChange={handleChange}
              options={[
                { value: '', label: 'all' },
                { value: '1', label: 'Active' },
                { value: '2', label: 'In-Active' },
              ]}
            />
          </div>
        </div>
      </div>
      <p> {isLoading} </p>
      <div>
        <Table
          columns={columns}
          dataSource={customers}
          rowKey={(record) => record.id}
          onChange={handleTableChange}
          pagination={pagination}
          loading={isLoading}
          scroll={{ x: 1300 }}
          style={{ overflowX: "auto", whiteSpace: "nowrap" }}
        />
      </div>
    </div>
  );
};

export default Customers;
